<template>
  <div class="profile-steps">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 cus-step-wrap">
        <div class="flex_content mb-4">
          <ProgressBar v-if="$route.query['data-id']" :scale="progress"/>
        </div>
        <div class="step-progress__wrapper">
          <div class="step-progress__bar md-layout">
            <div class="md-medium-size-33 md-layout-item md-xsmall-size-100 custom-step-pro p-0">
              <div id="industryDiv" class="step-progress__step step-progress__step--valid" @click="selectedTab($event)">
                <span class="step">1</span>
                <div class="step-progress__step-icon fa fa-check"></div>
                <div class="step-progress__step-label">
                  <div class="arrow-up"></div>
                  Industry
                </div>
                <div class="step-progress__step-sub-label">
                  <div class="progress-step-actions">
                    <div class="action-text industry" @click="
												getData($store.getters.industry)
													? resetIndustry($event)
													: openSelector($event)
											">
                      {{
                        getData($store.getters.industry)
                            ? getData($store.getters.industry)
                            : "Select Industry"
                      }}
                      <md-icon v-if="$store.getters.industry != null" class="action-icon">replay</md-icon>
                    </div>
                    <div v-if="$store.getters.industry != null" class="favourite black-color">
                      <md-icon v-if="$store.getters.industry != null" class="action-icon" @click.native="favoriteIndustry">star</md-icon>
                      Add to Favorite
                    </div>
                  </div>
                </div>
                <div class="dropdownMenu">
                  <nav-tabs-card md-elevation="0" no-label>
                    <template slot="content">
                      <md-tabs id="selectorTab1" md-alignment="left">
                        <industry-tab/>
                      </md-tabs>
                    </template>
                  </nav-tabs-card>
                </div>
              </div>
              <div id="favouriteIndustryDiv" :class="
									this.isRetail
										? 'non-subscriber favourite_list'
										: 'favourite_list'
								" @click="isRetail ? {} : favorites($event)">
                <md-tooltip v-if="this.isRetail" class="width-tooltip" md-direction="right">Upgrade to a subscription to access this feature
                </md-tooltip>
                <i class="md-icon">star</i>Favorite Industries
                <div class="dropdownMenu">
                  <sidebar-search tab="industry" title="Favorite Industries"/>
                </div>
                <div id="industry_notify" class="notify">
                  Successfully Added to Favorite
                </div>
              </div>
            </div>
            <div :class="$store.getters.industry == null || $store.getters.type == 'Sole proprietorship' ? 'disabled' : ''" class="md-medium-size-33 md-layout-item md-xsmall-size-100 custom-step-pro p-0">
              <div id="marketDiv" class="step-progress__step step-progress__step--valid" @click="selectedTab($event)">
                <span class="step">2</span>
                <div class="step-progress__step-icon fa fa-check"></div>
                <div class="step-progress__step-label">
                  Market Area
                  <div class="arrow-up"></div>
                </div>
                <div class="step-progress__step-sub-label">
                  <div class="progress-step-actions">
                    <div class="action-text area" @click="
												getTitle($store.getters.marketArea)
													? resetMarket($event)
													: openSelector($event)
											">
                      {{
                        getTitle($store.getters.marketArea)
                            ? getTitle($store.getters.marketArea)
                            : "Select Market Area"
                      }}
                      <md-icon v-if="$store.getters.marketArea != null" class="action-icon">replay
                      </md-icon>
                    </div>
                    <div v-if="$store.getters.marketArea != null" class="favourite black-color">
                      <md-icon v-if="$store.getters.marketArea != null" class="action-icon" @click.native="favoriteMarket">star
                      </md-icon>
                      Favorite Market Areas
                    </div>
                  </div>
                </div>
                <div class="dropdownMenu">
                  <nav-tabs-card md-elevation="0" no-label>
                    <template slot="content">
                      <md-tabs id="selectorTab2" md-alignment="left">
                        <market-area-tab/>
                      </md-tabs>
                    </template>
                  </nav-tabs-card>
                </div>
              </div>
              <div id="favouriteAreaDiv" :class="this.isRetail ? 'non-subscriber favourite_list' : 'favourite_list'" @click="isRetail ? {} : favorites($event)">
                <md-tooltip v-if="this.isRetail" class="width-tooltip" md-direction="right">Upgrade to a subscription to access this feature</md-tooltip>
                <i class="md-icon">star</i>Favorite Market Areas
                <div class="dropdownMenu">
                  <sidebar-search tab="market_area" title="Favorite Market Areas"/>
                </div>
                <div id="market_notify" class="notify">Successfully Added to Favorite</div>
              </div>
            </div>
            <div :class="$store.getters.industry == null || $store.getters.type == 'Sole proprietorship' ? 'disabled' : ''" class="md-medium-size-33 md-layout-item md-xsmall-size-100 custom-step-pro p-0">
              <div id="salesDiv" class="step-progress__step step-progress__step--valid" @click="selectedTab($event)">
                <span class="step">3</span>
                <div class="step-progress__step-icon fa fa-check"></div>
                <div class="step-progress__step-label">
                  <div class="arrow-up"></div>
                  Sales Class
                </div>
                <div class="step-progress__step-sub-label">
                  <div class="progress-step-actions">
                    <div class="action-text sales" @click="getTitle($store.getters.salesClass) ? resetSales($event) : openSelector($event)">
                      {{ getTitle($store.getters.salesClass) ? getTitle($store.getters.salesClass) : " Select Sales Class" }}
                      <md-icon v-if="$store.getters.salesClass != null" class="action-icon">replay</md-icon>
                    </div>
                    <div v-if="$store.getters.salesClass != null" class="favourite black-color">
                      <md-icon v-if="$store.getters.salesClass != null" class="action-icon" @click.native="favoriteSales">star
                      </md-icon>
                      Favorite Sale Classes
                    </div>
                  </div>
                </div>
                <div class="dropdownMenu">
                  <nav-tabs-card md-elevation="0" no-label>
                    <template slot="content">
                      <md-tabs id="selectorTab3" md-alignment="left">
                        <sales-class-tab/>
                      </md-tabs>
                    </template>
                  </nav-tabs-card>
                </div>
              </div>
              <div id="favouriteSalesDiv" :class="
									this.isRetail
										? 'non-subscriber favourite_list'
										: 'favourite_list'
								" @click="isRetail ? {} : favorites($event)">
                <md-tooltip v-if="this.isRetail" class="width-tooltip" md-direction="right">Upgrade to a subscription to access this feature
                </md-tooltip>
                <i class="md-icon">star</i>Favorite Sale Classes
                <div class="dropdownMenu">
                  <sidebar-search tab="sales_class" title="Favorite Sale Classes"/>
                </div>
                <div id="sale_notify" class="notify">
                  Successfully Added to Favorite
                </div>
              </div>
            </div>
            <div id="divStructure" :class="$store.getters.industry == null ? 'disabled' : ''" class="step-progress__step step-progress__step--active md-medium-size-50 md-layout-item md-xsmall-size-100 custom-step-pro" @click="selectPanel($event)">
              <span class="step">4</span>
              <div class="step-progress__step-icon fa fa-check"></div>
              <div class="step-progress__step-label">
                <div style="display: inline-flex">
                  Structure
                  <!-- <md-button
                    class="
                      classic-modal
                      md-icon-button
                      color-white
                      info-btn-custom
                    "
                    @click="classicModal = true"
                    :md-ripple="false"
                  >
                    <md-icon>report</md-icon>
                  </md-button>-->
                </div>
                <div class="arrow-up"></div>
              </div>
              <div class="step-progress__step-sub-label">
                <div class="progress-step-actions">
                  <div class="action-text structure" @click="openSelector">
                    {{
                      getTitle($store.getters.type)
                          ? getTitle($store.getters.type)
                          : "Industry Firms"
                    }}
                    <!-- <md-icon
                      @click.native="resetSales"
                      v-if="$store.getters.type != null"
                      class="action-icon"
                      >replay</md-icon
                    >-->
                  </div>
                </div>
              </div>
              <div class="dropdownMenu">
                <div>
                  <md-radio v-model="radioType" :value="false">Corporations and Partnerships
                  </md-radio>
                </div>
                <div>
                  <md-radio v-model="radioType" :value="true">Sole Proprietorships (1040C)
                  </md-radio>
                </div>
              </div>
            </div>
            <div id="divSeries" :class="$store.getters.industry == null ? 'disabled' : ''" class="step-progress__step step-progress__step--active md-medium-size-50 md-layout-item md-xsmall-size-100 custom-step-pro" @click="selectPanel($event)">
              <span class="step">5</span>
              <div class="step-progress__step-icon fa fa-check"></div>
              <div class="step-progress__step-label">
                Time Series
                <div class="arrow-up"></div>
              </div>
              <div class="step-progress__step-sub-label">
                <div class="progress-step-actions">
                  <div class="action-text series" @click="openSelector($event)">
                    {{ $store.getters.years }} Years Profile
                    <!-- <md-icon
                      @click.native="resetType"
                      v-if="$store.getters.years != null"
                      class="action-icon"
                      >replay</md-icon
                    >-->
                  </div>
                </div>
              </div>
              <div class="dropdownMenu">
                <div>
                  <md-radio v-model="radioSeries" :value="false">3 year profile
                  </md-radio>
                </div>
                <div>
                  <md-radio v-model="radioSeries" :value="true">5 year profile
                  </md-radio>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="step-progress__wrapper-after"></div> -->
        </div>
      </div>
    </div>
    <modal v-if="classicModal" @close="classicModal = false">
      <template slot="header">
        <h4 class="modal-title">Industry Profile Version</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="classicModal = false">
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <template slot="body">
        <p>
          This is where we will explain the difference between a regular IF profile and a SPIF profile. </p>
      </template>
      <template slot="footer">
        <md-button class="md-simple">Nice Button</md-button>
        <md-button class="md-danger md-simple" @click="classicModal = false">Close
        </md-button>
      </template>
    </modal>
  </div>
</template>
<script>
import {Modal, ProgressBar} from "@/components";
import axios from "axios";
import {NavTabsCard} from "@/components";
import IndustryTab from "./IndustryTab";
import MarketAreaTab from "./MarketAreaTab";
import SalesClassTab from "./SalesClassTab";
import SidebarSearch from "./SidebarSearch";
import {mapState} from "vuex";

export default {
  name: "profile-steps",
  components: {
    Modal,
    NavTabsCard,
    IndustryTab,
    MarketAreaTab,
    SalesClassTab,
    SidebarSearch,
    ProgressBar,
  },
  data() {
    return {
      radioType: false,
      radioSeries: true,
      classicModal: false,
      progress: 70,
      route: null,
    };
  },
  mounted() {
    this.$store.commit("SET_TYPE", "Industry firms");
    if (this.$route.name === "NewProfile")
      this.route = "/user/search_profiles/if";
    else this.route = "/user/search_reports/if";
    this.setIndustryClass();
    this.setSalesClass();
    this.setMarketClass();
  },
  methods: {
    openSelector(event) {
      let selectorDiv = null;
      if (event.target.classList.contains("industry"))
        selectorDiv = document.getElementById("industryDiv");
      else if (event.target.classList.contains("area"))
        selectorDiv = document.getElementById("marketDiv");
      else if (event.target.classList.contains("sales"))
        selectorDiv = document.getElementById("salesDiv");
      else if (event.target.classList.contains("structure"))
        selectorDiv = document.getElementById("divStructure");
      else if (event.target.classList.contains("series"))
        selectorDiv = document.getElementById("divSeries");
      if (selectorDiv && selectorDiv.classList.contains("open"))
        selectorDiv.classList.remove("open");
      else if (selectorDiv) selectorDiv.classList.add("open");
    },
    selectPanel(e) {
      let activeClass = e.target.parentElement;
      if (activeClass.classList.contains("open")) {
        activeClass.classList.remove("open");
      } else {
        activeClass.classList.add("open");
      }
    },
    getSearchState: async function () {
      let currentSession = localStorage.getItem(
          "vue-authenticate.vueauth_access_token"
      );
      await axios
          .post(
              process.env.VUE_APP_API_BASE_URL + this.route,
              {},
              {
                params: {
                  session_id: currentSession,
                  profile_id: this.profileId ? this.profileId : "0",
                  industry: this.getData(this.industry),
                  sales_class: this.getData(this.salesClass),
                  area: this.getData(this.marketArea),
                  years: this.$store.getters.years,
                  type:
                      this.$store.getters.type === "Industry firms" ? "if" : "spif",
                },
              }
          )
          .then((res) => {
            if (res.hasOwnProperty("data") && res.data.error) {
              this.$store.commit("SET_ERROR_BIT", true);
              this.$store.commit(
                  "SET_ERROR_INFO",
                  "<br>" +
                  "Server responded with error = True <br> errorCode: " +
                  res.data.errorCode +
                  `<br> ${process.env.VUE_APP_API_BASE_URL} + ${this.route} <br>`
              );
              throw new Error(
                  "<br>" +
                  "Server responded with error = True <br> errorCode: " +
                  res.data.errorCode
              );
            }
            const {id} = res.data;
            this.$store.commit("SET_PROFILE_ID", id);
          });
    },
    getData: function (name) {
      if (name) {
        return name.split("[")[1].split("]")[0];
      }
    },
    getTitle: function (name) {
      if (name) {
        return name.split("[")[0];
      }
      return null;
    },
    favoriteIndustry: async function () {
      let notify = document.getElementById("industry_notify");
      let currentSession = localStorage.getItem(
          "vue-authenticate.vueauth_access_token"
      );
      const industryData = this.getData(this.$store.getters.industry);
      await axios
          .post(
              process.env.VUE_APP_API_BASE_URL + "/user/favorites/add",
              {},
              {
                params: {
                  session_id: currentSession,
                  category1: "universal",
                  category2: "industry",
                  data: industryData,
                  search1: this.$store.getters.industry,
                  search2: industryData,
                },
              }
          )
          .then((res) => {
            if (res.hasOwnProperty("data") && res.data.error) {
              this.$store.commit("SET_ERROR_BIT", true);
              this.$store.commit(
                  "SET_ERROR_INFO",
                  "<br>" +
                  "Server responded with error = True <br> errorCode: " +
                  res.data.errorCode +
                  `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/favorites/add" <br>`
              );
              throw new Error(
                  "<br>" +
                  "Server responded with error = True <br> errorCode: " +
                  res.data.errorCode
              );
            }
            this.$store.commit("PUSH_TO_FAVORITE_INDUSTRIES", {
              data: industryData,
              search1: this.$store.getters.industry,
              id: res.data.favorite_id,
            });
            notify.classList.add("show");
            setTimeout(function () {
              notify.classList.remove("show");
            }, 3000);
          });
    },
    favoriteMarket: async function () {
      let notify = document.getElementById("market_notify");
      let currentSession = localStorage.getItem(
          "vue-authenticate.vueauth_access_token"
      );
      const marketData = this.getData(this.$store.getters.marketArea);
      await axios
          .post(
              process.env.VUE_APP_API_BASE_URL + "/user/favorites/add",
              {},
              {
                params: {
                  session_id: currentSession,
                  category1: "universal",
                  category2: "market_area",
                  data: marketData,
                  search1: this.$store.getters.marketArea,
                  search2: marketData,
                },
              }
          )
          .then((res) => {
            if (res.hasOwnProperty("data") && res.data.error) {
              this.$store.commit("SET_ERROR_BIT", true);
              this.$store.commit(
                  "SET_ERROR_INFO",
                  "<br>" +
                  "Server responded with error = True <br> errorCode: " +
                  res.data.errorCode +
                  `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/favorites/add" <br>`
              );
              throw new Error(
                  "<br>" +
                  "Server responded with error = True <br> errorCode: " +
                  res.data.errorCode
              );
            }
            this.$store.commit("PUSH_TO_FAVORITE_MARKET_AREAS", {
              data: marketData,
              search1: this.$store.getters.marketArea,
              id: res.data.favorite_id,
            });
            notify.classList.add("show");
            setTimeout(function () {
              notify.classList.remove("show");
            }, 3000);
          });
    },
    favoriteSales: async function () {
      let notify = document.getElementById("sale_notify");
      let currentSession = localStorage.getItem(
          "vue-authenticate.vueauth_access_token"
      );
      const salesData = this.getData(this.$store.getters.salesClass);
      await axios
          .post(
              process.env.VUE_APP_API_BASE_URL + "/user/favorites/add",
              {},
              {
                params: {
                  session_id: currentSession,
                  category1: "universal",
                  category2: "sales_class",
                  data: salesData,
                  search1: this.$store.getters.salesClass,
                  search2: salesData,
                },
              }
          )
          .then((res) => {
            if (res.hasOwnProperty("data") && res.data.error) {
              this.$store.commit("SET_ERROR_BIT", true);
              this.$store.commit(
                  "SET_ERROR_INFO",
                  "<br>" +
                  "Server responded with error = True <br> errorCode: " +
                  res.data.errorCode +
                  `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/favorites/add" <br>`
              );
              throw new Error(
                  "<br>" +
                  "Server responded with error = True <br> errorCode: " +
                  res.data.errorCode
              );
            }
            this.$store.commit("PUSH_TO_FAVORITE_SALES_CLASSES", {
              data: salesData,
              search1: this.$store.getters.salesClass,
              id: res.data.favorite_id,
            });
            notify.classList.add("show");
            setTimeout(function () {
              notify.classList.remove("show");
            }, 3000);
          });
    },
    resetIndustry: async function () {
      this.$store.commit("SET_INDUSTRY", null);
      this.$store.commit("SET_SEARCH_INDUSTRIES", null);
      this.$store.commit("SET_SEARCH_LOADING_INDUSTRY", false);
      this.progress;
      let currentSession = localStorage.getItem(
          "vue-authenticate.vueauth_access_token"
      );
      await axios
          .post(
              process.env.VUE_APP_API_BASE_URL + this.route,
              {},
              {
                params: {
                  session_id: currentSession,
                  industry: "0",
                  profile_id: this.profileId ? this.profileId : "0",
                  years: this.$store.getters.years,
                  type:
                      this.$store.getters.type === "Industry firms" ? "if" : "spif",
                },
              }
          )
          .then((res) => {
            if (res.hasOwnProperty("data") && res.data.error) {
              this.$store.commit("SET_ERROR_BIT", true);
              this.$store.commit(
                  "SET_ERROR_INFO",
                  "<br>" +
                  "Server responded with error = True <br> errorCode: " +
                  res.data.errorCode +
                  `<br> ${process.env.VUE_APP_API_BASE_URL} + ${this.route} <br>`
              );
              throw new Error(
                  "<br>" +
                  "Server responded with error = True <br> errorCode: " +
                  res.data.errorCode
              );
            }
            const {id} = res.data;
            this.$store.commit("SET_PROFILE_ID", id);
          });
    },
    resetMarket: async function () {
      this.$store.commit("SET_MARKET_AREA", null);
      this.progress;
      let currentSession = localStorage.getItem(
          "vue-authenticate.vueauth_access_token"
      );
      await axios
          .post(
              process.env.VUE_APP_API_BASE_URL + this.route,
              {},
              {
                params: {
                  session_id: currentSession,
                  area: 0,
                  profile_id: this.profileId ? this.profileId : "0",
                  years: this.$store.getters.years,
                  type:
                      this.$store.getters.type === "Industry firms" ? "if" : "spif",
                },
              }
          )
          .then((res) => {
            if (res.hasOwnProperty("data") && res.data.error) {
              this.$store.commit("SET_ERROR_BIT", true);
              this.$store.commit(
                  "SET_ERROR_INFO",
                  "<br>" +
                  "Server responded with error = True <br> errorCode: " +
                  res.data.errorCode +
                  `<br> ${process.env.VUE_APP_API_BASE_URL} + ${this.route} <br>`
              );
              throw new Error(
                  "<br>" +
                  "Server responded with error = True <br> errorCode: " +
                  res.data.errorCode
              );
            }
            const {id} = res.data;
            this.$store.commit("SET_PROFILE_ID", id);
          });
    },
    resetSales: async function () {
      this.$store.commit("SET_SALES_CLASS", null);
      this.progress;
      let currentSession = localStorage.getItem(
          "vue-authenticate.vueauth_access_token"
      );
      await axios
          .post(
              process.env.VUE_APP_API_BASE_URL + this.route,
              {},
              {
                params: {
                  session_id: currentSession,
                  sales_class: "0",
                  profile_id: this.profileId ? this.profileId : "0",
                  years: this.$store.getters.years,
                  type: this.$store.getters.type === "Industry firms" ? "if" : "spif",
                },
              }
          )
          .then((res) => {
            if (res.hasOwnProperty("data") && res.data.error) {
              this.$store.commit("SET_ERROR_BIT", true);
              this.$store.commit(
                  "SET_ERROR_INFO",
                  "<br>" +
                  "Server responded with error = True <br> errorCode: " +
                  res.data.errorCode +
                  `<br> ${process.env.VUE_APP_API_BASE_URL} + ${this.route} <br>`
              );
              throw new Error(
                  "<br>" +
                  "Server responded with error = True <br> errorCode: " +
                  res.data.errorCode
              );
            }
            const {id} = res.data;
            this.$store.commit("SET_PROFILE_ID", id);
          });
    },
    toArray: function (arrLike) {
      return [].slice.call(arrLike);
    },
    setMarketClass: function () {
      if (this.$store.getters.marketArea != null) {
        document
            .querySelector("#marketDiv")
            .classList.remove("step-progress__step--valid");
        document
            .querySelector("#marketDiv")
            .classList.add("step-progress__step--active");
      } else {
        document
            .querySelector("#marketDiv")
            .classList.remove("step-progress__step--active");
        document
            .querySelector("#marketDiv")
            .classList.add("step-progress__step--valid");
      }
    },
    setSalesClass: function () {
      if (this.$store.getters.salesClass != null) {
        document
            .querySelector("#salesDiv")
            .classList.remove("step-progress__step--valid");
        document
            .querySelector("#salesDiv")
            .classList.add("step-progress__step--active");
      } else {
        document
            .querySelector("#salesDiv")
            .classList.remove("step-progress__step--active");
        document
            .querySelector("#salesDiv")
            .classList.add("step-progress__step--valid");
      }
    },
    setIndustryClass: function () {
      let div = document.querySelector("#industryDiv");
      if (div) {
        if (this.$store.getters.industry != null) {
          div.classList.remove("step-progress__step--valid");
          div.classList.add("step-progress__step--active");
        } else {
          div.classList.remove("step-progress__step--active");
          div.classList.add("step-progress__step--valid");
        }
      }
    },
    favorites: function (e) {
      let activeClass = e.target;
      this.validateClickOutside(activeClass);
      if (activeClass.classList.contains("open")) {
        activeClass.classList.remove("open");
      } else {
        activeClass.classList.add("open");
      }
    },
    selectedTab: function (e) {
      let activeClass = e.target.parentElement;
      if (activeClass) {
        if (activeClass.classList.contains("open")) {
          activeClass.classList.remove("open");
          this.validateClickOutside(activeClass);
          e.stopPropagation();
        } else {
          this.validateClickOutside(activeClass);
          e.stopPropagation();
          let elems = document.querySelector(".progress-step-actions");
          [].forEach.call(elems, function (el) {
            el.classList.remove("open");
          });
          activeClass.classList.add("open");
          // activeClass.nextElementSibling.classList.remove('open');
        }
        let elems = this.toArray(
            document.querySelectorAll(".md-tab-nav-button")
        );
        elems.forEach(function (el) {
          el.classList.remove("md-active");
        });
        let currentTab = parseInt(e.currentTarget.firstElementChild.innerText);
        document.querySelectorAll(".md-tab-nav-button")[currentTab - 1].classList.add("md-active");
      }
    },
    saveProfile: async function () {
      let currentSession = localStorage.getItem(
          "vue-authenticate.vueauth_access_token"
      );
      await axios
          .post(
              process.env.VUE_APP_API_BASE_URL + this.route,
              {},
              {
                params: {
                  session_id: currentSession,
                  profile_id: this.profileId ? this.profileId : "0",
                  industry: this.getData(this.industry),
                  sales_class: this.getData(this.salesClass),
                  area: this.getData(this.marketArea),
                  years: this.$store.getters.years,
                  type:
                      this.$store.getters.type === "Industry firms" ? "if" : "spif",
                },
              }
          )
          .then((res) => {
            if (res.hasOwnProperty("data") && res.data.error) {
              this.$store.commit("SET_ERROR_BIT", true);
              this.$store.commit(
                  "SET_ERROR_INFO",
                  "<br>" +
                  "Server responded with error = True <br> errorCode: " +
                  res.data.errorCode +
                  `<br> ${process.env.VUE_APP_API_BASE_URL} + ${this.route} <br>`
              );
              throw new Error(
                  "<br>" +
                  "Server responded with error = True <br> errorCode: " +
                  res.data.errorCode
              );
            }
            const {id} = res.data;
            this.$store.commit("SET_PROFILE_ID", id);
          });
    },
    validateClickOutside: function (activeClass) {
      let openClass = document.getElementsByClassName("open");
      if (openClass)
        [].forEach.call(openClass, function (el) {
          if (activeClass.id) el.classList.remove("open");
        });
    },
  },
  computed: {
    ...mapState({
      isRetail: (state) =>
          state.user.user_type.retail /*|| state.user.allow_retail*/ ? true : null,
    }),
    profileId() {
      return this.$store.getters.profileId;
    },
    industry() {
      return this.$store.getters.industry;
    },
    marketArea() {
      return this.$store.getters.marketArea;
    },
    salesClass() {
      return this.$store.getters.salesClass;
    },
  },
  watch: {
    industry(newValue, oldValue) {
      if (newValue) {
        this.setIndustryClass();
        this.progress += 10;
      }
      if (oldValue) {
        this.progress -= 10;
      }
    },
    marketArea(newValue, oldValue) {
      this.setMarketClass();
      if (newValue) {
        this.progress += 10;
      }
      if (oldValue) {
        this.progress -= 10;
      }
    },
    salesClass(newValue, oldValue) {
      this.setSalesClass();
      if (newValue) {
        this.progress += 10;
      }
      if (oldValue) {
        this.progress -= 10;
      }
    },
    radioSeries(newValue, oldValue) {
      newValue
          ? this.$store.commit("SET_YEARS", 5)
          : this.$store.commit("SET_YEARS", 3);
      this.getSearchState();
    },
    async radioType(newValue, oldValue) {
      if (newValue) {
        this.$store.commit("SET_MARKET_AREA", "US [9999]");
        this.setMarketClass();
        this.$store.commit("SET_SALES_CLASS", "Industrywide[1]");
        this.setSalesClass();
        this.$store.commit("SET_TYPE", "Sole proprietorship");
      } else {
        this.$store.commit("SET_TYPE", "Industry firms");
      }
      this.saveProfile();
    },
  },
};
</script>
<style lang="scss" scoped>

.info-btn-custom {
  background-color: white !important;

  &:hover {
    background-color: white !important;
    box-shadow: none;
  }
}

.step-progress__step:hover {
  cursor: pointer;
}

.action-text {
  opacity: 1 !important;
  transform: unset !important;
  font-size: 14px !important;
}

.custom-step-pro::before {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  height: 2px;
  width: 96%;
  background-color: grey;
  z-index: -1;
}

.custom-step-pro:last-child::before {
  content: none;
}

@media screen and (max-width: 1280px) and (min-width: 600px) {
  .custom-step-pro:nth-child(4),
  .custom-step-pro:nth-child(5) {
    margin-top: 130px;
  }

  .custom-step-pro:nth-child(3)::before {
    content: none;
  }

  .cus-step-wrap {
    padding-top: 20px;
  }

  .step-progress__step:after {
    width: 30px !important;
    height: 30px !important;
  }

  .step-progress__step span {
    font-size: 18px;
  }

  .step-progress__step-icon {
    font-size: 12px !important;
  }
}

@media only screen and (max-width: 600px) {
  .custom-step-pro::before {
    left: -6%;
    top: 369%;
    width: 27%;
    transform: rotate(90deg);
  }

  .custom-step-pro {
    margin-bottom: 80px;
  }

  .step-progress__step-label .arrow-up {
    display: none;
  }

  .step-progress__step:after {
    left: 8%;
    top: 150%;
  }

  .step-progress__step-icon {
    left: 8%;
    top: 150%;
  }

  .step-progress__step-label {
    top: 0;
    left: 63%;
  }

  .custom-step-pro:nth-child(4),
  .custom-step-pro:nth-child(5) {
    margin-top: unset;
  }

  .step-progress__step:after {
    width: 30px !important;
    height: 30px !important;
  }

  .step-progress__step span {
    font-size: 18px;
  }

  .step-progress__step-icon {
    font-size: 12px !important;
  }

  .cus-step-wrap {
    padding-top: 20px;
  }
}
</style>
